import React from "react";
import banner4 from "../assets/banner4.jpg"; // replace with actual image path

export default function ProjectProgrammeReviews() {
  return (
    <section className="py-5">

      {/* Heading */}
      <div className="text-center mb-3">
        <h2 className="main-section-title fw-bold">Project & Programme Reviews</h2>
        <p className="text-muted small">
          Independent evaluations to improve project performance and governance.
        </p>
      </div>

      {/* Image */}
      <div className="mb-4">
        <img 
          src={banner4} 
          alt="Project & Programme Reviews" 
          className="img-fluid rounded w-100"
        />
      </div>

      {/* Elaborative Text */}
      <div className="container">
        <p className="text-muted fs-6">
          Zamani Sabios Group delivers independent reviews of projects and programmes, 
          examining performance, governance structures, implementation challenges, 
          and results frameworks. Our team provides practical recommendations 
          for improving operational efficiency, accountability, and impact. 
          These reviews help organisations optimise resources, strengthen processes, 
          and ensure that project objectives are achieved effectively and sustainably.
        </p>
      </div>

    </section>
  );
}
